import React from 'react';
import { Stack, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

// Inline error message shown below a field: red icon + red text.
const FieldError = ({ message }) => {
  if (!message) return null;
  return (
    <Stack
      role="alert"
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ mt: '4px' }}
    >
      <ErrorIcon sx={{ fontSize: 16, color: '#9E231B' }} />
      <Typography
        sx={{ fontSize: '12px', lineHeight: '16px', color: '#9E231B' }}
      >
        {message}
      </Typography>
    </Stack>
  );
};

export default FieldError;
